import type { ListingTab } from './types';

export const LISTING_TABS: ListingTab[] = ['listings', 'review', 'reported'];

export const LISTINGS_TAB_KEY = 'admin:listings:tab';
